import React from 'react';
import './LineTypeItem.scss';

// LineWeight component
interface LineWeightProps {
  thickness?: number;
  isDashed?: boolean;
  height?: number;
}

export const LineWeight: React.FC<LineWeightProps> = ({ thickness, isDashed = false, height }) => {
  return (
    <div
      className={`line-weight ${isDashed ? 'line-weight--dashed' : ''}`}
      style={{ height: height ? `${height}px` : `${thickness}px` }}
    />
  );
};
